var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PopupModal',{attrs:{"isShow":true}},[_c('template',{slot:"body"},[_c('iframe',{staticStyle:{"position":"fixed","top":"0","height":"100%","width":"100%"},attrs:{"src":_vm.url}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }